if (!customElements.get("f-cart-goal")) {
  /**
   * `cart-update` payloads are not normalized across the theme: most emit a
   * Shopify cart object (`items_subtotal_price` on the root), but
   * `quick-order-list.js` emits `{ cart, item_count, ... }` with the cart
   * nested. Read both and fall back to `getState()` when subtotal is missing.
   */
  function subtotalFromCartEvent(state) {
    if (!state || typeof state !== "object") return null;
    const root = state.items_subtotal_price;
    if (typeof root === "number" && !Number.isNaN(root)) return root;
    const nested = state.cart && state.cart.items_subtotal_price;
    if (typeof nested === "number" && !Number.isNaN(nested)) return nested;
    return null;
  }

  class FCartGoal extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        cartDrawer: ".f-cart-drawer__inner",
        leftToSpend: "[data-left-to-spend]",
        cartGoalTitle: ".f-cartgoal__title",
      };

      this.confettiShow = false;
      this.goalDone = false;
      this.goal =
        Number(this.dataset.cartGoal) *
          Number(window.Shopify.currency.rate || 1) || 0;
      this.money_format = window.FoxThemeSettings.money_format;
      this.enableConfetti = this.dataset.enableConfetti === "true";
    }

    connectedCallback() {
      this.updateCartGoal(Number(this.dataset.cartTotal));
      window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.cartUpdate, (state) => {
        const subtotal = subtotalFromCartEvent(state);
        if (subtotal !== null) {
          this.updateCartGoal(subtotal);
          return;
        }
        void window.FoxThemeCartHelpers.getState().then((newCart) => {
          if (newCart) {
            this.updateCartGoal(newCart.items_subtotal_price);
          }
        });
      });
      this.confettiShow = this.goalDone;
    }

    updateCartGoal(state) {
      if (state > 0) {
        this.classList.remove("hidden");
      } else {
        this.classList.add("hidden");
      }

      this.cartTotal = state / 100;
      this.goalLeft = this.goal - this.cartTotal;
      this.goalDone = this.goalLeft <= 0;

      this.percent = (this.cartTotal * 100) / this.goal;

      if (this.percent >= 100) this.percent = 100;

      if (this.cartTotal >= this.goal) {
        this.style.setProperty("--progress", `${this.percent}%`);
        this.classList.add("f-cartgoal--done", "shakeY");
        this.dataset.total = this.cartTotal;
      } else {
        let spend = (this.goal - this.cartTotal) * 100;
        const leftEl = this.querySelector(this.selectors.leftToSpend);
        if (leftEl) {
          leftEl.innerHTML = formatMoney(spend, this.money_format);
        }
        this.classList.remove("f-cartgoal--done", "shakeY");
        this.style.setProperty("--progress", `${this.percent}%`);
        this.dataset.total = this.cartTotal;
      }

      if (this.goalLeft <= 0 && this.enableConfetti) {
        this.showConfetti();
      } else {
        this.confettiShow = false;
      }
    }

    showConfetti() {
      const cartDrawer = this.closest(this.selectors.cartDrawer);
      const cartTemplate = this.closest(".cart-template");

      if (!this.confettiShow && (cartDrawer || cartTemplate)) {
        setTimeout(() => {
          if (cartDrawer) {
            new window.FoxTheme.Confetti(cartDrawer);
          }
          if (cartTemplate) {
            new window.FoxTheme.Confetti(document.body);
          }
          this.confettiShow = true;
        }, 800);
      }
    }
  }

  customElements.define("f-cart-goal", FCartGoal);
}
